import { BASE_COLOR_SCHEMA } from 'components/landing/constants';
import CompanyInformationAbout from './company-information-about';
import Image from 'core/image';
import insuranceLogoMapper from 'utils/insurance-logo-mapper/insurance-logo-mapper';
import LandingSection from '../components/landing-section';
import LandingTable from '../tables/landing-table';
import styles from 'styles/LandingSelectorInsuranceTable.module.scss';
import { useCulture } from 'context/CultureContext';
import { usePageInfo } from 'context/PageInfoContext';
import { useTranslations } from 'next-intl';
import variables from 'styles/variables.module.scss';

const InsuranceProfileSection = () => {
    const { pageInfo } = usePageInfo();
    const { culture } = useCulture();
    const t = useTranslations('company-information');
    return (
        <LandingSection className={styles.section}>
            <div className={styles.logo_wrapper}>
                <Image
                    src={insuranceLogoMapper(
                        pageInfo.company_code,
                        culture,
                        'colored'
                    )}
                    alt={`${pageInfo.company_code} Logo`}
                    width={340.32}
                    height={120}
                />
            </div>
            <h2 style={{ color: variables.textColor }}>{t('title')}</h2>
            <LandingTable
                tableName="company_profile_table"
                tableData={pageInfo.page_context.page_dinamic_data.company_details}
                colorSchema={BASE_COLOR_SCHEMA}
            />
            <CompanyInformationAbout colorSchema={BASE_COLOR_SCHEMA} />
        </LandingSection>
    );
};

InsuranceProfileSection.propTypes = {};

export default InsuranceProfileSection;
